import React from "react";

const EmailValidated = (props) => (
    <svg
        width={200}
        height={114}
        viewBox="0 0 200 114"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width={200} height={113.733} rx={30} fill="#F0F3F6" />
        <g opacity={0.4} clipPath="url(#clip0_2941_3243)">
            <path
                d="M39.2258 81.354C35.5844 81.354 32.2383 80.7471 29.1874 79.5333C26.1365 78.3195 23.4956 76.5972 21.2649 74.3664C19.0341 72.1357 17.3118 69.4948 16.098 66.4439C14.8842 63.393 14.2773 60.0469 14.2773 56.4055C14.2773 52.7641 14.8842 49.418 16.098 46.3671C17.3118 43.3162 19.0341 40.6753 21.2649 38.4446C23.4956 36.2138 26.1365 34.4915 29.1874 33.2777C32.2383 32.0639 35.5844 31.457 39.2258 31.457C42.8672 31.457 46.2134 32.0639 49.2643 33.2777C52.3152 34.4915 54.956 36.2138 57.1868 38.4446C59.4175 40.6753 61.1398 43.3162 62.3536 46.3671C63.5674 49.418 64.1743 52.7641 64.1743 56.4055C64.1743 59.4564 63.7478 62.1628 62.8949 64.5248C62.0419 66.854 60.861 68.6911 59.3519 70.0361C57.8757 71.3811 56.1534 72.0537 54.1851 72.0537C52.3808 72.0537 50.8881 71.5616 49.7071 70.5774C48.5589 69.6261 47.9848 68.2974 47.9848 66.5916V64.3772C47.3615 65.4926 46.5414 66.4932 45.5244 67.3789C44.5403 68.2646 43.4577 68.9536 42.2767 69.4456C41.0957 69.9377 39.9147 70.1838 38.7337 70.1838C36.1421 70.1838 33.8457 69.5933 31.8446 68.4123C29.8763 67.2313 28.318 65.6074 27.1698 63.5407C26.0545 61.4739 25.4968 59.0955 25.4968 56.4055C25.4968 53.7155 26.0873 51.3371 27.2683 49.2703C28.4493 47.2036 30.0731 45.5797 32.1399 44.3987C34.2066 43.2178 36.5686 42.6273 39.2258 42.6273C41.9159 42.6273 44.2942 43.2178 46.361 44.3987C48.4277 45.5797 50.0516 47.2036 51.2326 49.2703C52.4136 51.3371 53.0041 53.7155 53.0041 56.4055V64.2788C53.0041 65.0989 53.1353 65.7386 53.3977 66.1979C53.6602 66.6572 54.0866 66.8868 54.6771 66.8868C55.4645 66.8868 56.1862 66.4439 56.8423 65.5582C57.5312 64.6725 58.0725 63.4423 58.4662 61.8676C58.8598 60.2601 59.0567 58.4394 59.0567 56.4055C59.0567 53.4858 58.5646 50.8286 57.5804 48.4338C56.6291 46.0062 55.2676 43.9067 53.4961 42.1352C51.7247 40.3637 49.6251 39.0023 47.1975 38.0509C44.8027 37.0667 42.1455 36.5747 39.2258 36.5747C36.3389 36.5747 33.6817 37.0667 31.2541 38.0509C28.8265 39.0023 26.727 40.3637 24.9555 42.1352C23.184 43.9067 21.8062 46.0062 20.822 48.4338C19.8707 50.8286 19.395 53.4858 19.395 56.4055C19.395 59.2924 19.8707 61.9496 20.822 64.3772C21.8062 66.8048 23.184 68.9043 24.9555 70.6758C26.727 72.4473 28.8265 73.8087 31.2541 74.7601C33.6817 75.7443 36.3389 76.2363 39.2258 76.2363C40.538 76.2363 41.9487 76.0723 43.4577 75.7443C44.9996 75.449 46.3118 75.0554 47.3944 74.5633C48.5097 74.0056 49.4119 73.94 50.1008 74.3664C50.8225 74.7929 51.1834 75.613 51.1834 76.8268C51.1834 77.7126 50.6749 78.4835 49.6579 79.1396C48.641 79.8285 47.2303 80.3698 45.426 80.7635C43.6217 81.1572 41.555 81.354 39.2258 81.354ZM39.2258 65.0169C40.9317 65.0169 42.4243 64.6561 43.7037 63.9343C44.9832 63.1798 45.9837 62.1628 46.7054 60.8834C47.46 59.5712 47.8372 58.0786 47.8372 56.4055C47.8372 54.6996 47.46 53.207 46.7054 51.9276C45.9837 50.6482 44.9832 49.6476 43.7037 48.9259C42.4243 48.1714 40.9317 47.7941 39.2258 47.7941C37.5199 47.7941 36.0273 48.1714 34.7479 48.9259C33.4685 49.6476 32.4515 50.6482 31.697 51.9276C30.9753 53.207 30.6144 54.6996 30.6144 56.4055C30.6144 58.0786 30.9753 59.5712 31.697 60.8834C32.4515 62.1628 33.4685 63.1798 34.7479 63.9343C36.0273 64.6561 37.5199 65.0169 39.2258 65.0169Z"
                fill="#A1BACA"
            />
        </g>
        <g opacity={0.9}>
            <rect
                x={141.866}
                y={56.1339}
                width={40.4633}
                height={40.4633}
                rx={20.2316}
                fill="#3EC28F"
            />
        </g>
        <g opacity={0.3}>
            <rect
                x={136.702}
                y={51.5797}
                width={50.9817}
                height={49.8969}
                rx={24.9485}
                fill="#3EC28F"
            />
        </g>
        <path
            d="M170.598 70.0767C170.208 69.6839 169.572 69.6827 169.181 70.0742L159.486 79.7694C159.096 80.1594 158.464 80.16 158.073 79.7708L155.12 76.8297C154.73 76.4405 154.098 76.4411 153.708 76.8311L152.743 77.7955C152.353 78.186 152.353 78.8192 152.743 79.2097L158.073 84.5394C158.463 84.9299 159.097 84.9299 159.487 84.5394L171.563 72.4633C171.953 72.0738 171.954 71.4425 171.566 71.0516L170.598 70.0767Z"
            fill="#FEFEFE"
        />
        <rect
            x={75.9307}
            y={37.9653}
            width={53.5043}
            height={13.867}
            rx={4}
            fill="#9DB5C6"
        />
        <rect
            opacity={0.4}
            x={75.9307}
            y={61.9223}
            width={39.7554}
            height={13.867}
            rx={4}
            fill="#9DB5C6"
        />
        <defs>
            <clipPath id="clip0_2941_3243">
                <rect
                    width={49.8969}
                    height={49.8969}
                    fill="white"
                    transform="translate(14.1006 31.457)"
                />
            </clipPath>
        </defs>
    </svg>
);

export default EmailValidated;
